'use strict';

exports.__esModule = true;
exports.default = withStatusCode;

var _reactRouterDispatcher = require('react-router-dispatcher');

var _getStatusCodeAction = require('./getStatusCodeAction');

var _getStatusCodeAction2 = _interopRequireDefault(_getStatusCodeAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function withStatusCode(statusCode) {
    return (0, _reactRouterDispatcher.withActions)(null, (0, _getStatusCodeAction2.default)(statusCode));
}